import { put, takeLatest, call } from "redux-saga/effects";
import AutorizacionActions, {
  Types as AutorizacionTypes,
} from "../../stores/autorizacion/Actions";
import AutorizacionService from "../../services/autorizacion/AutorizacionService";
import ProcedimientoService from "../../services/procedimiento/ProcedimientoService";
import AuthService from "../../services/auth/AuthService";
import ResponseCode from "../../services/ResponseCode";
import { getActualYear, getActualDate } from "../../utils/DateUtils";
import {
  DEFAULT_MOTIVO_CANCELACION,
  COBERTURAS_MONTOS_MODIFICABLES,
  CODIGO_TIPO_SERVICIO_AUTORIZACION,
  ESTADO_DIAGNOSTICO_DEFINITIVO,
  CHECK_DIAGNOSTICO_DEFINITIVO,
} from "../../containers/autorizacion/utils/AutorizacionConstant";
import {
  getObjetoAutorizacion,
  desfragmentarCodigoAutorizacion,
  fragmentarCodigoAutorizacion,
  agruparObjetoAutorizacion,
} from "../../containers/autorizacion/utils/AutorizacionUtils";
import { groupBy } from "../../utils/ArrayUtil";
import { isEmptyValue, cleanString } from "../../utils/StringUtil";
import {
  isValidNumber,
  isServerErrorResponseCode,
  isServerErrorResponseMessage,
  isServerErrorResponse,
} from "../../utils/ValidationUtil";
import { DATE_FORMATS } from "../../utils/Constant";
import moment from "moment";

function* crearAutorizacion(request) {
  yield put(AutorizacionActions.crearAutorizacionLoading());

  const { numeroSesion, procedimientos, tipoServicio, servicio } =
    request.payload;

  let procedimientosNoInsertados = [];

  for (let procedimiento of procedimientos) {
    let requestValidar = {
      codigoProcedimiento: procedimiento?.cobertura,
      tipoServicio,
      frecuencia: procedimiento?.cantidad,
    };

    if (
      (COBERTURAS_MONTOS_MODIFICABLES.includes(procedimiento?.cobertura) ||
        Number(servicio) ===
          Number(CODIGO_TIPO_SERVICIO_AUTORIZACION.ALTO_COSTO)) &&
      !isEmptyValue(procedimiento?.montoReclamado) &&
      Number(procedimiento?.montoReclamado) > 0
    ) {
      requestValidar.monto = Number(procedimiento?.montoReclamado);
    }

    const validarProcedimientoResponse = yield call(
      ProcedimientoService.validarProcedimiento,
      AuthService.handleRequestSession(requestValidar, numeroSesion)
    );

    if (isServerErrorResponseMessage(validarProcedimientoResponse)) {
      procedimientosNoInsertados.push(procedimiento?.cobertura);
    }

    const requestInsertar = {
      frecuencia: procedimiento?.cantidad,
    };

    const insertarProcedimientoResponse = yield call(
      ProcedimientoService.insertarProcedimiento,
      AuthService.handleRequestSession(requestInsertar, numeroSesion)
    );

    if (isServerErrorResponseCode(insertarProcedimientoResponse)) {
      procedimientosNoInsertados.push(procedimiento?.cobertura);
    }
  }

  const crearAutorizacionResponse = yield call(
    AutorizacionService.crearAutorizacion,
    AuthService.handleRequestSession(
      request.payload?.requestAutorizar,
      numeroSesion
    )
  );

  if (isServerErrorResponse(crearAutorizacionResponse)) {
    yield put(
      AutorizacionActions.crearAutorizacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (crearAutorizacionResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      AutorizacionActions.crearAutorizacionFailure(
        crearAutorizacionResponse?.respuesta
      )
    );
    return;
  }

  const { compania, autorizacion } = crearAutorizacionResponse?.data;

  const esAutorizacionMadre =
    crearAutorizacionResponse?.data?.esAutorizacionMadre;

  let errorRegistrarInfo = null;

  if (request.payload.insertarMetadata) {
    const {
      contacto,
      diagnosticos,
      medicoTratante,
      comentarios,
      exentoDeFisico,
    } = request.payload?.requestRegistrarInfo;

    if (esAutorizacionMadre) {
      const autorizacionHumano = desfragmentarCodigoAutorizacion(
        crearAutorizacionResponse?.data?.autorizacionesRelacionadas?.autorizacionHumano?.toUpperCase()
      );

      const autorizacionPrimera = desfragmentarCodigoAutorizacion(
        crearAutorizacionResponse?.data?.autorizacionesRelacionadas?.autorizacionPrimera?.toUpperCase()
      );

      if (autorizacionHumano) {
        const requestRegistrarInfoAutorizacionHumano = {
          anio: getActualYear(),
          compania: autorizacionHumano?.compania,
          ramo: autorizacionHumano?.ramo,
          secuencial: autorizacionHumano?.secuencial,
          contacto: contacto,
          diagnosticos: diagnosticos,
          medicoTratante: medicoTratante,
          comentarios: comentarios,
          exentoDeFisico: exentoDeFisico,
        };

        const responseRegistrarInfoHumano = yield call(
          AutorizacionService.registrarInfoAutorizacion,
          requestRegistrarInfoAutorizacionHumano
        );

        errorRegistrarInfo = responseRegistrarInfoHumano?.error;

        if (exentoDeFisico) {
          const { documents } = request.payload;
          for (const documento of documents) {
            let formData = new FormData();
            formData.append("anio", getActualYear());
            formData.append("compania", autorizacionHumano?.compania);
            formData.append("ramo", autorizacionHumano?.ramo);
            formData.append("secuencial", autorizacionHumano?.secuencial);
            formData.append("descripcion", "Papper Free");
            formData.append("file", documento);
            yield call(AutorizacionService.subirArchivoAutorizacion, formData);
          }
        }
      }

      if (autorizacionPrimera) {
        const requestRegistrarInfoAutorizacionPrimera = {
          anio: getActualYear(),
          compania: autorizacionPrimera?.compania,
          ramo: autorizacionPrimera?.ramo,
          secuencial: autorizacionPrimera?.secuencial,
          contacto: contacto,
          diagnosticos: diagnosticos,
          medicoTratante: medicoTratante,
          comentarios: comentarios,
          exentoDeFisico: exentoDeFisico,
        };

        const responseRegistrarInfoPrimera = yield call(
          AutorizacionService.registrarInfoAutorizacionPrimera,
          requestRegistrarInfoAutorizacionPrimera
        );

        errorRegistrarInfo =
          errorRegistrarInfo === null
            ? responseRegistrarInfoPrimera?.data?.error
            : responseRegistrarInfoPrimera?.data?.error !== null
            ? `${errorRegistrarInfo} , ${responseRegistrarInfoPrimera?.data?.error}`
            : null;

        if (exentoDeFisico) {
          const { documents } = request.payload;
          for (const documento of documents) {
            let formData = new FormData();
            formData.append("anio", getActualYear());
            formData.append("compania", autorizacionPrimera?.compania);
            formData.append("ramo", autorizacionPrimera?.ramo);
            formData.append("secuencial", autorizacionPrimera?.secuencial);
            formData.append("descripcion", "Papper Free");
            formData.append("file", documento);
            yield call(AutorizacionService.subirArchivoAutorizacion, formData);
          }
        }
      }
    } else {
      const requestRegistrarInfoAutorizacion = {
        anio: getActualYear(),
        compania: compania?.codigo,
        ramo: autorizacion?.ramo,
        secuencial: autorizacion?.secuencial,
        contacto: contacto,
        diagnosticos: diagnosticos,
        medicoTratante: medicoTratante,
        comentarios: comentarios,
        exentoDeFisico: exentoDeFisico,
      };

      const responseRegistrarInfo = yield call(
        AutorizacionService.registrarInfoAutorizacion,
        requestRegistrarInfoAutorizacion
      );

      errorRegistrarInfo = responseRegistrarInfo?.error;

      if (exentoDeFisico) {
        const { documents } = request.payload;
        for (const documento of documents) {
          let formData = new FormData();
          formData.append("anio", getActualYear());
          formData.append("compania", compania?.codigo);
          formData.append("ramo", autorizacion?.ramo);
          formData.append("secuencial", autorizacion?.secuencial);
          formData.append("descripcion", "Papper Free");
          formData.append("file", documento);
          yield call(AutorizacionService.subirArchivoAutorizacion, formData);
        }
      }
    }
  }

  let infoAutorizacionMadre = null;

  if (esAutorizacionMadre) {
    const autorizacionMadre = desfragmentarCodigoAutorizacion(
      crearAutorizacionResponse?.data?.autorizacion?.numeroAutorizacion?.toUpperCase()
    );

    const requestDetalleMadre = {
      numeroAutorizacionMadre: `${getActualYear()}${
        autorizacionMadre?.compania
      }${autorizacionMadre?.ramo}${autorizacionMadre?.secuencial}`,
    };

    const getAutorizacionMadreResponse = yield call(
      AutorizacionService.getDetalleAutorizacionMadre,
      requestDetalleMadre
    );

    infoAutorizacionMadre = getAutorizacionMadreResponse?.data;
  }

  let mensajeProcedimientosNoInsertados = null;

  if (procedimientosNoInsertados?.length > 0) {
    let procedimientosFiltrados = [...new Set(procedimientosNoInsertados)];

    mensajeProcedimientosNoInsertados =
      "No se insertaron los siguientes procedimientos: " +
      procedimientosFiltrados?.join(", ");
  }

  yield put(
    AutorizacionActions.crearAutorizacionSuccess({
      compania,
      autorizacion,
      errorRegistrarInfo,
      esAutorizacionMadre,
      autorizacionesRelacionadas:
        crearAutorizacionResponse?.data?.autorizacionesRelacionadas,
      infoAutorizacionMadre,
      mensajeProcedimientosNoInsertados,
    })
  );
}

function* cancelarAutorizacion(request) {
  yield put(AutorizacionActions.cancelarAutorizacionLoading());

  const { numeroSesion, autorizacion } = request.payload;

  const requestCancelar = {
    numeroAutorizacion: autorizacion?.numeroAutorizacion,
    numeroPlastico: autorizacion?.numeroAsegurado,
    codigoMotivo: DEFAULT_MOTIVO_CANCELACION,
  };

  const cancelarAutorizacionResponse = yield call(
    AutorizacionService.cancelarAutorizacion,
    AuthService.handleRequestSession(requestCancelar, numeroSesion)
  );

  if (!cancelarAutorizacionResponse?.respuesta) {
    yield put(
      AutorizacionActions.cancelarAutorizacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    cancelarAutorizacionResponse?.respuesta?.codigo ===
    ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      AutorizacionActions.cancelarAutorizacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    cancelarAutorizacionResponse?.respuesta?.codigo !== ResponseCode.OK.code
  ) {
    yield put(
      AutorizacionActions.cancelarAutorizacionFailure(
        cancelarAutorizacionResponse?.respuesta
      )
    );
    return;
  }

  yield put(AutorizacionActions.cancelarAutorizacionSuccess({ autorizacion }));
}

function* getAutorizacion(request) {
  yield put(AutorizacionActions.getAutorizacionLoading());

  const { numeroAutorizacion, ano, tipoPss, codigoPss, desdePantallaConsulta } =
    request.payload;

  const getAutorizacionResponse = yield call(
    AutorizacionService.getDetalleAutorizacion,
    { numeroAutorizacion, ano }
  );

  if (!getAutorizacionResponse?.respuesta) {
    yield put(
      AutorizacionActions.getAutorizacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    getAutorizacionResponse?.respuesta?.codigo ===
    ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      AutorizacionActions.getAutorizacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (getAutorizacionResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      AutorizacionActions.getAutorizacionFailure(
        getAutorizacionResponse?.respuesta
      )
    );
    return;
  }

  const { data } = getAutorizacionResponse;

  let dataGmm = null;

  if (data?.reclamacionGmm) {
    const numeroAutorizacionGmm = fragmentarCodigoAutorizacion(
      data?.reclamacionGmm?.compania,
      data?.reclamacionGmm?.ramo,
      data?.reclamacionGmm?.secuencial
    );

    const autorizacionGmmResponse = yield call(
      AutorizacionService.getDetalleAutorizacion,
      { numeroAutorizacion: numeroAutorizacionGmm, ano }
    );

    if (autorizacionGmmResponse?.data?.procedimientos?.length > 0) {
      dataGmm = {
        ...autorizacionGmmResponse?.data,
        numeroAutorizacion: numeroAutorizacionGmm,
      };
    }
  }

  const objetoAutorizacion = getObjetoAutorizacion(
    data?.reclamacion?.numeroAutorizacion
  );

  const getInfoRequest = {
    Anio: objetoAutorizacion?.anio,
    Compania: objetoAutorizacion?.compania,
    Ramo: objetoAutorizacion?.ramo,
    Secuencial: objetoAutorizacion?.secuencial,
    FechaServicioDesde: moment(objetoAutorizacion?.fecha).format(
      DATE_FORMATS.middledash_ymd
    ),
    FechaServicioHasta: getActualDate(),
    TipoReclamante: tipoPss,
    Reclamante: codigoPss,
  };

  const infoResponse = yield call(
    AutorizacionService.getInfoAutorizacion,
    getInfoRequest
  );

  const info = infoResponse?.length > 0 ? infoResponse[0] : null;

  let infoAutorizacionMadre = null;

  if (desdePantallaConsulta && data?.reclamacion?.numeroAutorizacionMadre) {
    const requestDetalleMadre = {
      numeroAutorizacionMadre: data?.reclamacion?.numeroAutorizacionMadre,
    };

    const getAutorizacionMadreResponse = yield call(
      AutorizacionService.getDetalleAutorizacionMadre,
      requestDetalleMadre
    );

    infoAutorizacionMadre = getAutorizacionMadreResponse?.data;
  }

  yield put(
    AutorizacionActions.getAutorizacionSuccess({
      data,
      dataGmm,
      info,
      autorizacionLegacy: objetoAutorizacion,
      infoAutorizacionMadre,
      mostrarMontosMadre: infoAutorizacionMadre !== null,
    })
  );
}

function* reactivarAutorizacion(request) {
  yield put(AutorizacionActions.reactivarAutorizacionLoading());

  const response = yield call(
    AutorizacionService.reactivarAutorizacion,
    request.payload
  );

  if (!response?.respuesta) {
    yield put(
      AutorizacionActions.reactivarAutorizacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code) {
    yield put(
      AutorizacionActions.reactivarAutorizacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (response?.respuesta?.mensaje !== ResponseCode.OK.message) {
    yield put(
      AutorizacionActions.reactivarAutorizacionFailure(response?.respuesta)
    );
    return;
  }

  const { data } = response;

  yield put(AutorizacionActions.reactivarAutorizacionSuccess(data));
}

function* consultarAutorizaciones(request) {
  const {
    numeroBusqueda,
    fechaInicio,
    fechaFin,
    compania,
    prefijo,
    pagina,
    tamanoPagina,
  } = request.payload;

  yield put(AutorizacionActions.consultarAutorizacionesLoading());

  let requestAutorizaciones = {
    FechaInicio: fechaInicio,
    FechaFin: fechaFin,
    Compania: compania,
    Pagina: pagina,
    TamanoPagina: tamanoPagina,
  };

  if (!isEmptyValue(numeroBusqueda)) {
    if (isValidNumber(numeroBusqueda)) {
      requestAutorizaciones.NumeroPlastico = numeroBusqueda;
    } else {
      try {
        const autorizacion = desfragmentarCodigoAutorizacion(
          numeroBusqueda?.toUpperCase()
        );
        requestAutorizaciones.Ramo = autorizacion?.ramo || 0;
        requestAutorizaciones.Secuencial = autorizacion?.secuencial || 0;
      } catch (error) {}
    }
  }

  const response = yield call(
    AutorizacionService.getAutorizaciones,
    requestAutorizaciones
  );

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      AutorizacionActions.consultarAutorizacionesFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    response?.respuesta?.mensaje?.toLowerCase() !==
    ResponseCode.OK.message.toLowerCase()
  ) {
    yield put(
      AutorizacionActions.consultarAutorizacionesFailure(response?.respuesta)
    );
    return;
  }

  const result = {
    paginacion: response?.paginacion,
    autorizaciones: response?.data?.autorizaciones
      ?.map((autorizacion) => {
        return {
          key: autorizacion?.secuencial,
          numeroAutorizacion: `${prefijo}${+autorizacion?.ramo}-${
            autorizacion?.secuencial
          }`,
          fechaServicio: autorizacion?.fechaApertura,
          numeroAsegurado: autorizacion?.numeroPlastico,
          estado: autorizacion?.estatus,
          descripcionEstatus: autorizacion?.descripcionEstatus,
          numeroAutorizacionMadre: autorizacion?.numeroAutorizacionMadre,
        };
      })
      ?.sort((a, b) => {
        const fechaA = new Date(a.fechaServicio);
        const fechaB = new Date(b.fechaServicio);
        return fechaB - fechaA;
      }),
  };

  yield put(AutorizacionActions.consultarAutorizacionesSuccess(result));
}

function* limpiarDatosAutorizacion() {
  yield put(AutorizacionActions.limpiarDatosAutorizacionLoading());

  yield put(AutorizacionActions.crearAutorizacionSuccess({}));
}

export function* formAutorizacionDiagnostico(request) {
  yield put(AutorizacionActions.formAutorizacionDiagnosticoLoading());

  yield put(
    AutorizacionActions.formAutorizacionDiagnosticoSuccess(request?.payload)
  );
}

function* getAutorizacionesDiagnostico(request) {
  yield put(AutorizacionActions.getAutorizacionesDiagnosticoLoading());

  const {
    fechaInicio,
    fechaFin,
    tipoReclamante,
    reclamante,
    compania,
    formAutorizacionDiagnosticoData,
  } = request.payload;

  const getAutorizacionesRequest = {
    Compania: compania,
    FechaServicioDesde: moment(fechaInicio).format(DATE_FORMATS.middledash_ymd),
    FechaServicioHasta: moment(fechaFin).format(DATE_FORMATS.middledash_ymd),
    TipoReclamante: tipoReclamante,
    Reclamante: reclamante,
  };

  const getAutorizacionesResponse = yield call(
    AutorizacionService.getInfoAutorizacion,
    getAutorizacionesRequest
  );

  let result = [];

  if (getAutorizacionesResponse?.length > 0) {
    let agrupadasPorAutorizacion = groupBy(
      getAutorizacionesResponse,
      "numeroAutorizacion"
    );

    agrupadasPorAutorizacion.forEach((autorizacionAagrupada) => {
      result.push(agruparObjetoAutorizacion(autorizacionAagrupada));
    });

    result = result.map((autorizacion) => {
      return {
        ...autorizacion,
        key: autorizacion.numeroAutorizacion,
        esDiagnosticoDefinitivo:
          autorizacion?.diagnosticoMetaData?.esDiagnosticoDefinitivo,
        estado: autorizacion?.diagnosticoMetaData?.esDiagnosticoDefinitivo
          ? ESTADO_DIAGNOSTICO_DEFINITIVO.CONFIRMADO
          : ESTADO_DIAGNOSTICO_DEFINITIVO.PENDIENTE_CONFIRMAR,
      };
    });

    const sortDates = (a, b) =>
      moment(a.fechaServicio) - moment(b.fechaServicio);

    result = result.sort(sortDates);

    result = result?.filter((item) => item.esDiagnosticoDefinitivo === false);

    yield put(
      AutorizacionActions.formAutorizacionDiagnosticoSuccess({
        ...formAutorizacionDiagnosticoData,
        autorizaciones: result,
        fechaInicio,
        fechaFin,
      })
    );
  } else {
    yield put(
      AutorizacionActions.formAutorizacionDiagnosticoSuccess({
        ...formAutorizacionDiagnosticoData,
        fechaInicio,
        fechaFin,
        autorizaciones: [],
      })
    );
  }
}

function* modificarDiagnosticoDefinitivo(request) {
  yield put(AutorizacionActions.modificarDiagnosticoDefinitivoLoading());

  const {
    numeroAutorizacion,
    diagnosticoDefinitivo,
    codigoDiagnostico,
    diagnostico,
    formAutorizacionDiagnosticoData,
    formHandler,
  } = request.payload;

  const objetoAutorizacion = getObjetoAutorizacion(numeroAutorizacion);

  const modificarDiagnosticoRequest = {
    anio: Number(objetoAutorizacion?.anio),
    compania: Number(objetoAutorizacion?.compania),
    ramo: Number(objetoAutorizacion?.ramo),
    secuencial: Number(objetoAutorizacion?.secuencial),
    codigoDiagnostico: cleanString(codigoDiagnostico),
    diagnosticoDefinitivo: diagnosticoDefinitivo
      ? CHECK_DIAGNOSTICO_DEFINITIVO.SI_ES_DEFINITIVO
      : CHECK_DIAGNOSTICO_DEFINITIVO.NO_ES_DEFINITIVO,
  };

  const modificarDiagnosticoResponse = yield call(
    AutorizacionService.modificarDiagnosticoDefinitivo,
    modificarDiagnosticoRequest
  );

  if (
    modificarDiagnosticoResponse?.mensaje?.toUpperCase() ===
    ResponseCode.OK.message
  ) {
    const autorizaciones = formAutorizacionDiagnosticoData?.autorizaciones.map(
      (autorizacion) => {
        if (autorizacion.numeroAutorizacion === numeroAutorizacion) {
          return {
            ...autorizacion,
            diagnostico,
            diagnosticoMetaData: {
              ...autorizacion.diagnosticoMetaData,
              codigoDiagnostico,
            },
          };
        }
        return autorizacion;
      }
    );

    yield put(
      AutorizacionActions.formAutorizacionDiagnosticoSuccess({
        ...formAutorizacionDiagnosticoData,
        autorizaciones,
        alertConfig: {
          type: "success",
          title: "Diagnóstico modificado satisfactoriamente.",
          onConfirm: () => {
            formHandler({
              ...formAutorizacionDiagnosticoData,
              autorizaciones,
              showAlert: false,
              showModalModificarDiagnostico: false,
            });
          },
        },
        showAlert: true,
        showModalModificarDiagnostico: false,
      })
    );
  } else {
    yield put(
      AutorizacionActions.formAutorizacionDiagnosticoSuccess({
        ...formAutorizacionDiagnosticoData,
        alertConfig: {
          type: "error",
          title: "¡Hola!",
          message: "Ocurrió un error inesperado al modificar el diagnóstico.",
          onConfirm: () => {
            formHandler({
              ...formAutorizacionDiagnosticoData,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      })
    );
  }
}

function* confirmarDiagnosticoDefinitivo(request) {
  yield put(AutorizacionActions.confirmarDiagnosticoDefinitivoLoading());

  const { numeroAutorizacion, formAutorizacionDiagnosticoData, formHandler } =
    request.payload;

  const objetoAutorizacion = getObjetoAutorizacion(numeroAutorizacion);

  const modificarDiagnosticoRequest = {
    anio: Number(objetoAutorizacion?.anio),
    compania: Number(objetoAutorizacion?.compania),
    ramo: Number(objetoAutorizacion?.ramo),
    secuencial: Number(objetoAutorizacion?.secuencial),
    diagnosticoDefinitivo: CHECK_DIAGNOSTICO_DEFINITIVO.SI_ES_DEFINITIVO,
  };

  const modificarDiagnosticoResponse = yield call(
    AutorizacionService.modificarDiagnosticoDefinitivo,
    modificarDiagnosticoRequest
  );

  if (
    modificarDiagnosticoResponse?.mensaje?.toUpperCase() ===
    ResponseCode.OK.message
  ) {
    const autorizaciones = formAutorizacionDiagnosticoData?.autorizaciones.map(
      (autorizacion) => {
        if (autorizacion.numeroAutorizacion === numeroAutorizacion) {
          return {
            ...autorizacion,
            esDiagnosticoDefinitivo: true,
            estado: ESTADO_DIAGNOSTICO_DEFINITIVO.CONFIRMADO,
          };
        }
        return autorizacion;
      }
    );

    yield put(
      AutorizacionActions.formAutorizacionDiagnosticoSuccess({
        ...formAutorizacionDiagnosticoData,
        autorizaciones,
        alertConfig: {
          type: "success",
          title: "Diagnóstico confirmado satisfactoriamente.",
          onConfirm: () => {
            formHandler({
              ...formAutorizacionDiagnosticoData,
              autorizaciones,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      })
    );
  } else {
    yield put(
      AutorizacionActions.formAutorizacionDiagnosticoSuccess({
        ...formAutorizacionDiagnosticoData,
        alertConfig: {
          type: "error",
          title: "¡Hola!",
          message:
            "Ocurrió un error inesperado al marcar el diagnóstico como definitivo.",
          onConfirm: () => {
            formHandler({
              ...formAutorizacionDiagnosticoData,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      })
    );
  }
}

function* descargarReporteVoucher(request) {
  yield put(AutorizacionActions.descargarReporteVoucherLoading());

  yield call(AutorizacionService.descargarReporteVoucher, request.payload);

  yield put(
    AutorizacionActions.descargarReporteVoucherSuccess(ResponseCode.OK)
  );
}

const exportedArray = [
  takeLatest(AutorizacionTypes.CREAR_AUTORIZACION, crearAutorizacion),
  takeLatest(AutorizacionTypes.CANCELAR_AUTORIZACION, cancelarAutorizacion),
  takeLatest(AutorizacionTypes.GET_AUTORIZACION, getAutorizacion),
  takeLatest(AutorizacionTypes.REACTIVAR_AUTORIZACION, reactivarAutorizacion),
  takeLatest(
    AutorizacionTypes.CONSULTAR_AUTORIZACIONES,
    consultarAutorizaciones
  ),
  takeLatest(
    AutorizacionTypes.LIMPIAR_DATOS_AUTORIZACION,
    limpiarDatosAutorizacion
  ),
  takeLatest(
    AutorizacionTypes.FORM_AUTORIZACION_DIAGNOSTICO,
    formAutorizacionDiagnostico
  ),
  takeLatest(
    AutorizacionTypes.GET_AUTORIZACIONES_DIAGNOSTICO,
    getAutorizacionesDiagnostico
  ),
  takeLatest(
    AutorizacionTypes.MODIFICAR_DIAGNOSTICO_DEFINITIVO,
    modificarDiagnosticoDefinitivo
  ),
  takeLatest(
    AutorizacionTypes.CONFIRMAR_DIAGNOSTICO_DEFINITIVO,
    confirmarDiagnosticoDefinitivo
  ),
  takeLatest(
    AutorizacionTypes.DESCARGAR_REPORTE_VOUCHER,
    descargarReporteVoucher
  ),
];

export default exportedArray;
